export default __webpack_public_path__ + "static/media/pic4.a21c712b.jpg";